import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

/** /admin no longer shows the legacy dashboard — land on booking calendar. */
export default function AdminHomeRedirect() {
	const location = useLocation();
	const hash = (location.hash || '').replace(/^#/, '');

	if (hash === 'users') {
		return <Redirect to="/admin/users_list" />;
	}

	return <Redirect to="/admin/booking_calendar" />;
}
